/**
 * Local dev: Research-Work-API on port 8888.
 * Production backend: mocklocapp.netlify.app (see REACT_APP_API_BACKEND_URL).
 * Production browser: /.netlify/functions on mockloc.netlify.app (local Netlify
 * function proxies server-side to mocklocapp — same origin, no CORS).
 */
const LOCAL_API_BASE_URL = 'http://localhost:8888/.netlify/functions';

export const PRODUCTION_API_BACKEND_URL =
  'https://mocklocapp.netlify.app/.netlify/functions';

const PRODUCTION_BROWSER_API_BASE_URL = '/.netlify/functions';

export function getApiBackendUrl(): string {
  const fromEnv = process.env.REACT_APP_API_BACKEND_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/+$/, '');
  }
  return PRODUCTION_API_BACKEND_URL;
}

/** URL used for fetch() — proxy path in production to avoid cross-origin CORS. */
export function getApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_API_BASE_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/+$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return LOCAL_API_BASE_URL;
  }
  return PRODUCTION_BROWSER_API_BASE_URL;
}

export function accountsUrl(): string {
  return `${getApiBaseUrl()}/accounts`;
}

/** Password login/signup. Matches the Android app (`/accounts-v2`). */
export function accountsAuthUrl(): string {
  return `${getApiBaseUrl()}/accounts-v2`;
}

export function syncedDataUrl(): string {
  return `${getApiBaseUrl()}/get-all-synced-data-by-userid`;
}

export function videosAndArticleUrl(): string {
  return `${getApiBaseUrl()}/videos-and-article`;
}
